// TODO: This component should be replaced with PageHeader from 'components/Library/Header/HeaderExports'
// The existing component is already exported in LibraryExports.ts and provides the same functionality
import SubHeader from 'components/Library/Header/HeaderExports';
import { Tabs } from '@idaho-aeyc/ui-kit';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-shadow: none;
`;

const StyledTabs = styled(Tabs)`
  margin-top: 8px;
  box-shadow: none;

  .ant-tabs-nav {
    margin-bottom: 0;
    border-bottom: none;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: transparent;
    }
  }

  .ant-tabs-content-holder {
    margin: 0;
    padding: 16px;
    background-color: #f5f5f5;
    border: none;
    border-top: none;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }

  .ant-tabs-content {
    margin: 0;
    padding: 0;
    min-height: 0;
    border: none;
  }
`;

interface PageHeaderProps {
  subtitle?: string;
  subtitleIcon?: any;
  tabs?: any[];
  activeTabKey?: string;
  onTabChange?: (key: string) => void;
}

const PageHeader = ({
  subtitle,
  subtitleIcon,
  tabs,
  activeTabKey,
  onTabChange,
}: PageHeaderProps) => {
  return (
    <HeaderContainer>
      {subtitle && (
        <SubHeader title={subtitle} icon={subtitleIcon} iconSize={16} />
      )}

      {tabs && tabs.length > 0 && (
        <StyledTabs
          activeKey={activeTabKey}
          items={tabs}
          onChange={onTabChange}
          destroyInactiveTabPane={false}
        />
      )}
    </HeaderContainer>
  );
};

export default PageHeader;
